<ng-template
  [tuiDialogOptions]="{ label: dialogTitle, size: 'm' }"
  [(tuiDialog)]="open"
  (tuiDialogClose)="onDialogClose()"
>
  <p class="text-sm text-[#191C30E5] mb-3">
    Client: <strong>{{ clientLabel() }}</strong>
  </p>
  <p class="text-sm text-[#6B6D80] mb-4" *ngIf="!isEditMode">
    This will extend membership by one year from the renewal date, record the
    renewal fee for reports, and reactivate the client if they are inactive.
  </p>
  <p class="text-sm text-[#6B6D80] mb-4" *ngIf="isEditMode">
    Update the renewal date or fee for this record. If this becomes the latest
    renewal by date, the client&apos;s current expiry will be updated to match.
  </p>

  <label tuiLabel class="block mb-4">
    <tui-input-date
      [(ngModel)]="renewalDate"
      class="w-full"
      [disabled]="busy"
    >
      Renewal date
      <input tuiTextfieldLegacy />
    </tui-input-date>
  </label>

  <label tuiLabel class="block mb-2">
    <tui-input
      type="number"
      class="w-full"
      [(ngModel)]="fee"
      [disabled]="busy"
    >
      Renewal fee (LKR)
      <input tuiTextfieldLegacy type="number" />
    </tui-input>
  </label>
  <p class="text-xs text-[#6B6D80] mb-4" *ngIf="!isEditMode">
    System fee: LKR {{ systemRenewalFee | number : "1.2-2" }}
  </p>

  <div class="mb-4">
    <p class="text-sm font-medium text-[#3E4A58] mb-2">Valid until</p>
    <p class="text-base font-semibold text-[#526ED3] m-0">{{ newExpiryPreview() }}</p>
  </div>

  <label tuiLabel class="block mb-6">
    <tui-textarea
      class="w-full"
      [(ngModel)]="notes"
      [disabled]="busy"
      [expandable]="true"
    >
      Notes (optional)
      <textarea tuiTextfieldLegacy placeholder="Optional notes"></textarea>
    </tui-textarea>
  </label>

  <div class="flex justify-end gap-3">
    <button
      appearance="flat"
      tuiButton
      type="button"
      [disabled]="busy"
      (click)="onCancel()"
    >
      Cancel
    </button>
    <button
      appearance="primary"
      tuiButton
      type="button"
      [disabled]="!renewalDate || busy"
      (click)="onConfirm()"
    >
      {{ confirmLabel }}
    </button>
  </div>
</ng-template>
